import { render, staticRenderFns } from "./PreparePricing.vue?vue&type=template&id=6fc63a4d&"
import script from "./PreparePricing.vue?vue&type=script&lang=js&"
export * from "./PreparePricing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports